export const countWords = (s: string) => {
    let newString = String(s);
    newString = newString.replace(/(^\s*)|(\s*$)/gi, ''); // exclude  start and end white-space
    newString = newString.replace(/[ ]{2,}/gi, ' '); // 2 or more space to 1
    newString = newString.replace(/\n /, '\n'); // exclude newline with a start spacing
    return newString.split(' ').filter((str) => {
        return str !== '';
    }).length;
};